
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bonus",
      function () {
        return require("private-next-pages/bonus/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bonus"])
      });
    }
  